var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThankyou = function SvgThankyou(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 89,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#thankyou_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F9C795",
    d: "M45 12.55v55.331c0 9.051-3.018 10.56-6.035 12.068a18.7 18.7 0 0 0-4.525 3.017c-.498 0-.996-.015-1.463-.03-13.727-.77-15.13-12.038-15.13-12.038 13.576-7.542 12.067-19.61 12.067-25.644a21.3 21.3 0 0 1 3.289-10.167 10.85 10.85 0 0 0 1.478-4.495l1.086-11.932 2.399-7.21a3.5 3.5 0 0 1 2.58-2.309q.371-.09.754-.09a3.503 3.503 0 0 1 3.5 3.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDD7AD",
    d: "M43.49 12.55v55.332c0 9.05-3.016 10.559-6.033 12.067a18.9 18.9 0 0 0-4.48 2.987c-13.727-.77-15.13-12.038-15.13-12.038 13.576-7.542 12.067-19.61 12.067-25.643a21.3 21.3 0 0 1 3.289-10.168 10.85 10.85 0 0 0 1.478-4.495l1.086-11.932 2.399-7.21a3.5 3.5 0 0 1 2.58-2.308 3.48 3.48 0 0 1 2.745 3.409"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9C795",
    d: "M45 3.937v8.614a3.507 3.507 0 0 0-6.834-1.102l-2.398 7.21L37.125 3.59A3.92 3.92 0 0 1 41.062 0 3.94 3.94 0 0 1 45 3.937"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B97D3",
    d: "M34.44 82.966v1.524a3.017 3.017 0 0 1-3.001 3.017l-27.153.105a3.017 3.017 0 0 1-3.032-3.017V77.16a3.02 3.02 0 0 1 1.569-2.64 95.6 95.6 0 0 1 13.003-5.913 1.508 1.508 0 0 1 2.021 1.418v.874s1.509 12.068 16.593 12.068"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9C795",
    d: "m54.232 18.66-2.399-7.21A3.507 3.507 0 0 0 45 12.55V3.938A3.94 3.94 0 0 1 48.937 0a3.92 3.92 0 0 1 3.937 3.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9C795",
    d: "M72.153 70.898s-1.403 11.269-15.13 12.038c-.468.015-.966.03-1.464.03a18.7 18.7 0 0 0-4.525-3.017C48.017 78.441 45 76.932 45 67.881v-55.33a3.503 3.503 0 0 1 3.5-3.5q.382 0 .754.09a3.5 3.5 0 0 1 2.58 2.308l2.398 7.21 1.086 11.933c.156 1.589.66 3.124 1.478 4.495a21.3 21.3 0 0 1 3.289 10.167c0 6.034-1.509 18.102 12.068 25.644"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDD7AD",
    d: "M72.152 70.899s-1.403 11.268-15.13 12.037a18.9 18.9 0 0 0-4.48-2.987c-3.017-1.508-6.034-3.017-6.034-12.067V12.55a3.48 3.48 0 0 1 2.745-3.41 3.5 3.5 0 0 1 2.58 2.309l2.398 7.21 1.086 11.932c.156 1.59.661 3.124 1.479 4.495a21.3 21.3 0 0 1 3.288 10.167c0 6.034-1.508 18.102 12.068 25.645"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B97D3",
    d: "M88.745 77.159v7.436a3.017 3.017 0 0 1-3.032 3.017l-27.152-.105a3.017 3.017 0 0 1-3.002-3.017v-1.524c15.084 0 16.593-12.068 16.593-12.068v-.874a1.508 1.508 0 0 1 2.021-1.418 95.6 95.6 0 0 1 13.003 5.913 3.02 3.02 0 0 1 1.569 2.64"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "thankyou_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h89v89H.5z"
  })))));
};
export default SvgThankyou;